import React, { useEffect, useState } from 'react'
import Loading from '../../Components/ui/Loading';
import { formatToCurrency, loadScript } from '../../utils/commonFunction';
import Footer from '../../Components/common/Footer';
import { logo, logoGray } from '../../assets/images';
import { useNavigate, useParams } from 'react-router-dom';
import { GetReviveRenewData } from '../../api/RenewPlan';
import { paymentFailureService, paymentSuccessService } from '../../api/Register';
import { tostE, tostS } from '../../config/tostConfig';
import { GetPaymentData } from '../../api/common';
import { RAZORPAY_KEY } from '../../config/constant';

export default function RenewRevive() {
    const { app_id } = useParams();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [getDataLoading, setGetDataLoading] = useState(false);
    const [data, setData] = useState({});
    const [check, setCheck] = useState(false);

    const getData = async () => {
    setGetDataLoading(true);
    try {
      const res = await GetReviveRenewData(app_id);
      if (res.status === 200) {
        setData(res.data.data);
      }
    } catch (error) {
      console.log(error);
    //   navigate("/");
    } finally {
      setGetDataLoading(false);
    }
  } 

  useEffect(() => {
    getData();
    loadScript("https://checkout.razorpay.com/v1/checkout.js");
  }, []); // eslint-disable-line


  const handleMakePayment = async () => {
      setLoading(true);
      try {
        const res = await GetPaymentData(app_id, data.total, "revive_renew");
        if (res.status === 200 && res.data.success) {
  
          const respData = res.data.data;
  
          const options = {
            key: RAZORPAY_KEY, // Replace with your Razorpay key ID
            amount: respData.total_amount * 100, // Amount in the smallest currency unit (e.g., paise for INR)
            currency: 'INR',
            name: 'EEMA',
            description: 'Event & Entertainment Management Association',
            image: logo.src,
            order_id: respData.unique_order_id, // Replace with your generated order ID
            handler: async function (response) {
              const sendData = {
                ...response,
                history_id: data.plan_history.id,
                history_type: "revive_renew"
              };
              setGetDataLoading(true);
              try {
                const res = await paymentSuccessService(sendData);
                if (res.status === 200 && res.data.success) {
                  tostS(`Payment successful!`);
                  navigate(`/`, { replace: true });
                } else {
                  tostE(res.message);
                }
              } catch (error) {
                tostE(error.message);
              } finally {
                setGetDataLoading(false);
              }
            },
            prefill: {
              name: respData.name,
              email: respData.email,
              contact: respData.mobile_number,
            },
            notes: {
              regarding: 'Renew Fee',
            },
            theme: {
              color: '#D37C51',
            },
          };
          const rzp = new window.Razorpay(options);
          rzp.on('payment.failed', async function (response) {
            setGetDataLoading(true);
            try {
              const res = await paymentFailureService({
                ...response.error,
                history_id: data.plan_history.id,
              });
              if (res.status === 200 && res.success) {
                tostE('Payment failed. Please try again.');
              }
            } catch (error) {
              console.log(error);
            } finally {
              setGetDataLoading(false);
            }
          });
  
          rzp.open();
  
        }
        // If payment link expired
        if(res.status === 200 && !res.data.success && res.data?.payment_link_expired){
          navigate(`/payment-expired`, { replace: true });
        }
      } catch (error) {
        tostE("Something went wrong");
      } finally {
        setLoading(false);
      }
  
    }
  

    return (
        <>
            {getDataLoading && <Loading />}
            <div className="customContainer p-4">
                <div className="headingTexts ">
                    <h2>Checkout</h2>
                    
                </div>

                <div className="row">
                    <div className="col-md-7 col-lg-7 col-xl-7 col-xxl-7">
                        <div className="orderDetails">
                            <div className="userdetailsCard">
                                <div className="dataRow">
                                    <div>Your Name </div>
                                    <div>{data.Name}</div>
                                </div>
                                <div className="dataRow">
                                    <div>Email</div>
                                    <div>{data.Email}</div>
                                </div>
                                <div className="dataRow">
                                    <div>Plan Name </div>
                                    <div>{data.Plan_Name}</div>
                                </div>
                                <div className="dataRow">
                                    <div>Annual Fees </div>
                                    <div>₹{formatToCurrency(data.Annual_Fees)}</div>
                                </div>
                                <div className="dataRow">
                                    <div>GST (18%)</div>
                                    <div>₹{formatToCurrency(data.gst)}</div>
                                </div>
                            </div>
                            <div className="confirmDetails">
                                <div className="form-check form-check-inline eligibleText">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id="inlineCheckbox1"
                                        checked={check}
                                        onChange={(e) => setCheck(e.target.checked)}
                                    />
                                    <label className="form-check-label" htmlFor="inlineCheckbox1" style={{ fontSize: "16px", fontWeight: "300" }}>
                                        By clicking Continue, I confirm the details of the membership as shown.
                                    </label>
                                </div>
                                <p className="m-0" style={{ color: "#343434" }}>**If you feel any discrepancy in the data, or you want to get the information changed, reach out to the <a href="mailto:generalsecretary@eemaindia.com" style={{ color: "#D37C51" }}>generalsecretary@eemaindia.com</a> at this stage only.</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-5 col-lg-5 col-xl-4 offset-xl-1 col-xxl-4 offset-xxl-1">
                        <div className="text-end">
                            {" "}
                            <img src={logoGray} alt="" />{" "}
                        </div>

                        <div className="totalAmount">
                            <div>
                                {" "}
                                <strong>₹{formatToCurrency(data.total)}</strong>
                            </div>
                            <p>You have to pay</p>
                        </div>
                    </div>
                </div>
            </div>
            <Footer
                isNextAllowed={!loading && check}
                isBackAllowed={false}
                hideBackButton
                className='justify-content-end'
                nextButtonAction={() => { handleMakePayment() }}
            />
        </>
    )
}
